import { render, staticRenderFns } from "./wait_in_stock_code_list.vue?vue&type=template&id=6fdbf5b7"
import script from "./wait_in_stock_code_list.vue?vue&type=script&lang=js"
export * from "./wait_in_stock_code_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports